module.exports = __webpack_public_path__ + "static/media/light-motion-orbital-transfer.aea14bd.mp4";